// extracted by mini-css-extract-plugin
export default {"main":"Header_main__14iO5","button":"Header_button__IxLF0","title":"Header_title__48WPD","title-underline":"Header_title-underline__qDrhl","description":"Header_description__vuI-M"};